import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatCurrency } from "../../utils/function";
import { LogoIcon, MobileLogo, NotificationBell, UnactiveD } from "../../assets/icon";
import useRequest from "../hooks/use-req";
import useLogout from "../hooks/use-logout";
import LoginModal from "../../pages/auth/login-modal";
import { UserData } from "../../pages/recommender/wallet/types";
import NotificationsDrawer from "../notifications-drawer";
import { TopBanner } from "./top-banner";
interface UserDetailsProp {
  userData?: UserData | null;
}
export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const storedData = localStorage.getItem("vouchlink_waitlist");
  const data = storedData ? JSON.parse(storedData) : null;


  const navigate = useNavigate();
  const logout = useLogout();
  const handleSignOut = (e: React.MouseEvent) => {
    e.stopPropagation();
    logout();
    navigate("/login-waitlist");
    window.location.reload();
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="py-4 flex lg:px-[20px] justify-between relative">
      <div className="flex items-center gap-2">
        <div className="flex items-center mb-6">
          <Link to={'/'}>
            <LogoIcon />
          </Link>
        </div>

      </div>

      <div className="relative" ref={dropdownRef}>
        <div
          className="flex items-center gap-3 cursor-pointer md:bg-white bg-transparent border md:border-none rounded-full py-3 px-5 shadow-sm"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <h1 className="text-gray-700 lg:text-[14px] text-[12px] capitalize flex gap-1 font-medium">
            {data?.fname}
            <svg
              className={`mt- transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8504 5.97689L7.00039 10.123L3.15039 5.97689"
                stroke="#121212"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </h1>
          <UnactiveD />
        </div>

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="absolute right-0 mt-2 w-44 bg-white rounded-xl lg:text-[14px] text-[#121212] text-[12px] shadow-lg border border-gray-100 overflow-hidden z-50">
            {/* <button className="w-full text-left px-4 py-2  hover:bg-gray-100">
              My Profile
            </button>

            <button className="w-full text-left px-4 py-2  hover:bg-gray-100">
              Account Settings
            </button> */}

            {/* <hr className="my-1 border-gray-200" /> */}
            <button onClick={handleSignOut} className="w-full text-left px-4 py-3 hover:bg-gray-100">
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export const MiniHeader = () => {
  const navigate = useNavigate()
  function redirectLogin() {
    navigate('/login-waitlist')
  }
  return (
    <div className="flex items-center justify-between lg:px-[110px] max-w-7xl mx-auto  gap-2 pt-6">
      <Link to={'/'}>
        <LogoIcon />
      </Link>
      <button onClick={redirectLogin} aria-label="Open your rewards and waitlist account dashboard" className="text-white mt-2 shadow-md py-2 px-4 bg-black rounded-full text-[14px]">
        My Rewards
      </button>
    </div>
  )
}

export const MiniSignupHeader = () => {
  const navigate = useNavigate()
  function redirectLogin() {
    navigate('/')
  }
  return (
    <div className="flex max-w-7xl mx-auto pt-10 items-center justify-between mb-6 px-4 lg:px-[110px]">

      <Link to={'/'}>
        <LogoIcon />
      </Link>
      <button onClick={redirectLogin} className="text-white mt-2 font-normal shadow-md  h-[43px] px-4 bg-black rounded-full text-[16px]">
        Explore Rewards
      </button>
    </div>
  )
}


export const MainHeader: React.FC<UserDetailsProp> = ({ userData }) => {
  // Forces this component to re-render (and re-read the localStorage values below fresh)
  // when a login happens anywhere else in the tree — see the "auth-changed" listener below.
  const [authVersion, setAuthVersion] = useState(0);
  const authToken = localStorage.getItem("authToken");
  const userType = localStorage.getItem("user-type");
  const storedData = localStorage.getItem("userDetails");
  const data = storedData ? JSON.parse(storedData) : null;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [balance, setBalance] = useState<number>(0);
  const [showLogin, setShowLogin] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const handleAuthChanged = () => setAuthVersion((v) => v + 1);
    window.addEventListener("auth-changed", handleAuthChanged);
    return () => window.removeEventListener("auth-changed", handleAuthChanged);
  }, []);
  const { makeRequest: getRecommenderUser } = useRequest("/auth/auth/me", "GET", {
    Authorization: `Bearer ${authToken}`,
  });

  //Advertiser user
    const { makeRequest: getAdvertiserUser } = useRequest("/auth/auth/me-advertiser", "GET", {
    Authorization: `Bearer ${authToken}`,
  });

  const { makeRequest: getUnreadCount } = useRequest("/notifications/unread-count", "GET", {
    Authorization: authToken ? `Bearer ${authToken}` : undefined,
  });


  const navigate = useNavigate();
  const logout = useLogout();
  const handleSignOut = (e: React.MouseEvent) => {
    e.stopPropagation();
    logout();
    navigate("/login");
  };

  useEffect(() => {
    if (!authToken) return;
    // Admins have no wallet — only fetch for the two user types that do.
    if (userType !== 'RECOMMENDER' && userType !== 'ADVERTISER') return;

    const fetchBalance = async () => {
      if (userType === 'ADVERTISER') {
        // Advertiser profile response has no `data` wrapper — fields are top-level.
        const [response] = await getAdvertiserUser();
        setBalance(response?.recharged_wallet_balance || 0);
      } else {
        const [response] = await getRecommenderUser();
        setBalance(response?.data?.wallet_balance || 0);
      }
    };
    fetchBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, userType, authVersion]);

  useEffect(() => {
    if (!authToken) return;
    const fetchUnreadCount = async () => {
      const [response] = await getUnreadCount();
      if (response?.status) {
        setUnreadCount(response.unread_count || 0);
      }
    };
    fetchUnreadCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="fixed top-0 inset-x-0 z-50">
      <TopBanner />
      <header className="bg-white h-[76px] w-full shadow-sm mx-auto">
      <div className="py-2.5 flex lg:px-[40px] px-2  justify-between relative">
        <div className="flex items-center gap-2">
          <div className="md:flex gap-6 hidden items-center mb-6">
            <Link to="/">
              <LogoIcon />
            </Link>

            {userType === 'RECOMMENDER' && (
              <>
                {authToken && (
                  <button className="flex h-[43px] bg-[#121212] font-normal rounded-full text-white px-4 justify-center items-center  text-[16px]" onClick={() => navigate('/')}>
                    Explore Rewards
                  </button>
                )}
              </>
            )}


          </div>

          <div className="md:hidden flex  items-center mb-6">
            <Link to="/">
              <MobileLogo />
            </Link>
          </div>
        </div>


        <div className="relative flex" ref={dropdownRef}>
          {authToken && (
            <div
              className="flex items-center gap-3 cursor-pointer md:bg-white border border-[#DBDEF0] bg-transparent rounded-full h-[52px] px-5 shadow-sm"
              onClick={() => setIsOpen((prev) => !prev)}
            >
              {userData?.image_url ? (
                <img
                  src={userData.image_url}
                  alt={userData?.first_name || 'Profile'}
                  className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                />
              ) : (
                <UnactiveD />
              )}
              <div className="text-gray-700 lg:text-[14px] text-[12px] capitalize flex items-center gap-1 font-medium">

                {userData?.first_name || data?.first_name}
                <p className="p-1 bg-[#00A86B] rounded-full text-white">
                  {formatCurrency(balance, 'NGN', 'symbol')}
                </p>
                <svg
                  className={`mt-1 transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.8504 5.97689L7.00039 10.123L3.15039 5.97689"
                    stroke="#121212"
                    strokeWidth="1.05"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          )}

          {/* Dropdown Menu */}
          {isOpen && (
            userType === 'RECOMMENDER' ? (
              <div className="absolute right-0 mt-16 w-44 bg-white rounded-xl lg:text-[14px] text-[#121212] text-[12px] shadow-lg border border-gray-100 overflow-hidden z-50">
                <button onClick={() => navigate('/profile')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  My Profile
                </button>
                <button onClick={() => navigate('/links')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  My Links
                </button>
                <button onClick={() => navigate('/wallet')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Wallet
                </button>
                <button onClick={handleSignOut} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Sign Out
                </button>
              </div>
            ) : userType === 'ADVERTISER' ? (
              <div className="absolute right-0 mt-16 w-44 bg-white rounded-xl lg:text-[14px] text-[#121212] text-[12px] shadow-lg border border-gray-100 overflow-hidden z-50">
                <button onClick={() => navigate('/business/profile')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  My Profile
                </button>
                <button onClick={() => navigate('/business/recommenders')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Recommenders
                </button>
                <button onClick={() => navigate('/business/commissions')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Rewards
                </button>
                <button onClick={() => navigate('/business/wallet')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Wallet
                </button>
                <button onClick={handleSignOut} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Sign Out
                </button>
              </div>
            ) : (
              <div className="absolute right-0 mt-16 w-44 bg-white rounded-xl lg:text-[14px] text-[#121212] text-[12px] shadow-lg border border-gray-100 overflow-hidden z-50">
                <button onClick={() => navigate('/admin/overview')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Overview
                </button>
                <button onClick={() => navigate('/admin/recommender')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Recommenders
                </button>
                <button onClick={() => navigate('/admin/advertisers')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Advertisers
                </button>
                <button onClick={() => navigate('/admin/payouts')} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Recommender Payouts
                </button>
                <button onClick={handleSignOut} className="w-full text-left px-4 py-2 hover:bg-gray-100">
                  Sign Out
                </button>
              </div>
            )
          )}


          {authToken && (
            <button className="relative -mt-7" onClick={() => setShowNotifications(true)} aria-label="Open notifications">
              <NotificationBell />
          
                <span className="absolute top-9 right-0 z-10 min-w-[18px] h-[18px] px-1 rounded-full bg-[#00A86B] border-2 border-white text-white text-[10px] leading-none font-semibold flex items-center justify-center">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
            
            </button>
          )}

        </div>

        {!authToken && (
          <div className="flex items-center justify-center -mt-5 gap-3">
            <button onClick={() => setShowLogin(true)} className="shadow-md font-normal h-[43px] px-4 border border-[#000] rounded-full text-[16px]">
              Sign In
            </button>
            <button onClick={() => navigate('/signup')} className="flex h-[43px] bg-[#121212] font-normal rounded-full text-white px-4 justify-center items-center  text-[16px]">
              Get Started
            </button>
          </div>
        )}

      </div>
      </header>
      <LoginModal
        open={showLogin}
        onClose={() => setShowLogin(false)}
      />
      <NotificationsDrawer
        isOpen={showNotifications}
        onClose={() => setShowNotifications(false)}
        onUnreadCountChange={setUnreadCount}
      />
    </div>
  );
};


export const MiniSigninHeader = () => {
  const navigate = useNavigate()
  return (
    <div className="flex max-w-7xl mx-auto pt-10 items-center z-50 justify-between mb-6 px-4 lg:px-[110px]">
      <Link to={'/'}>
        <LogoIcon />
      </Link>
      <button
        onClick={(e) => {
          e.stopPropagation();

          if (window.location.pathname === "/") {
            window.location.reload();
          } else {
            navigate("/", { replace: true });
          }
        }}
        className="text-white mt-2 h-[43px] shadow-md font-normal py-2 px-4 bg-black rounded-full text-[16px]"
      >
        Explore Rewards
      </button>
    </div>
  )
}


export const MiniSigninFromWaitList = () => {
  return (
    <div className="flex max-w-7xl mx-auto pt-10 items-center justify-between mb-6 px-4 lg:px-[110px]">
      <LogoIcon />
    </div>
  )
}
